import { Avatar, Modal } from 'antd';
import { TaskComment } from '../../types/Comment';
import { BaseButton } from '../UI/BaseButton';
import { UserOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { getUserProfilePictureUrl } from '../../common/userHelper';
import colorTokens from '../../constants/design_system/colors';

interface DeleteCommentModalProps {
  comment: TaskComment | null;
  open: boolean;
  onOk: () => void;
  onCancel: () => void;
}

export const DeleteCommentModal = (props: DeleteCommentModalProps) => {
  const { open, onCancel, onOk, comment } = props;

  if (!comment) return null;

  return (
    <Modal
      title={
        <div className="text-brand-grey-dark text-base font-semibold mx-4 mt-3">
          You are about to delete the following comment:
        </div>
      }
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      centered
      width={640}
      footer={
        <div className="flex justify-end gap-2">
          <BaseButton type="secondary" size="medium" onClick={onCancel}>
            Cancel
          </BaseButton>
          <BaseButton type="primary" size="medium" danger onClick={onOk}>
            Delete Comment
          </BaseButton>
        </div>
      }
    >
      <div className="mx-4 mb-6 mt-6 p-3 bg-neutral-200 rounded flex flex-col gap-2 items-start justify-start text-brand-grey-dark text-sm font-medium">
        <div className="w-full">
          <div className="flex items-center">
            <Avatar
              icon={<UserOutlined />}
              size={24}
              style={{ backgroundColor: colorTokens.neutral[400], marginRight: '5px' }}
              src={getUserProfilePictureUrl(comment.User.profilePicturePath)}
            />
            <span className="text-sm font-semibold">{comment.User.fullName || comment.User.email}</span>
            <span className="text-xs text-neutral-900 ml-1">
              {dayjs(comment.createdAt).format('hh:mm A, MMM DD, YYYY ')}
            </span>
          </div>
          <div className="max-h-[314px] overflow-y-auto" dangerouslySetInnerHTML={{ __html: comment.content }} />
        </div>
      </div>
      <div className="mx-4 mb-6 text-neutral-900 text-sm font-normal">
        When you delete the comment, it and its attachments will no longer be visible to anybody. Are you sure you want
        to delete it?
      </div>
    </Modal>
  );
};
